module.exports = __webpack_public_path__ + "static/img/fullscreen-image_background.78b12d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact-us/fullscreen-image_background.png
// module id = /wpT
// module chunks = 0